import { type ConfirmPopupProps, DestruciveConfirmPopup } from '@neo/blocks/confirm-popup'
import type { ButtonProps } from '@neo/primitives/button'
import { usePermissions } from 'v2/shared/hooks/use-permissions'
import type { RbacModules, RbacPermissionTypes } from 'v2/types/rbac'

interface DestructiveConfirmPopupWithPermissionProps extends ConfirmPopupProps {
  /**
   * The module to check permissions against
   */
  module?: RbacModules
  /**
   * The type of permission to check (e.g., 'create', 'view', 'edit', 'delete')
   */
  permissionType?: RbacPermissionTypes
  /**
   * Whether the button is in a loading state
   */
  loading?: boolean
  disabled?: boolean
  disabledReason?: string
}

export const DestructiveConfirmPopupWithPermission = ({
  module,
  permissionType,
  loading = false,
  disabled,
  disabledReason,
  title,
  description,
  okButtonProps,
  children,
  ...props
}: DestructiveConfirmPopupWithPermissionProps & ButtonProps) => {
  const { hasPermission } = usePermissions()
  const shouldRenderButton = !module || !permissionType || hasPermission(module, permissionType)

  if (!shouldRenderButton) return null

  return (
    <DestruciveConfirmPopup
      disabled={disabled}
      disabledReason={disabledReason}
      title={title}
      description={description}
      okButtonProps={okButtonProps}
      loading={loading}
      {...props}
    >
      {children}
    </DestruciveConfirmPopup>
  )
}
